module.exports = __webpack_public_path__ + "media/bootstrap-icons/signpost-2-c8b01c45.svg";